import React, { useState } from "react";
import {
  useActionGroups,
  useAuthenticatedSocket,
  useDevice,
} from "../../../../Api/newSockets.api";

import Joystick from "../../../../components/Manual/Joystick";
import ManualTerminal from "../../../../components/Manual/ManualTerminal";
import { ReactComponent as SettingsIcon } from "../../../assets/icons/settings.svg";
import ProgramEditor from "../../../Develop/Program/ProgramEditor";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as ConsoleIcon } from "../../../../assets/icons/console.svg";
import { ReactComponent as PowerIcon } from "../../../../assets/icons/power.svg";
import { ReactComponent as ArrowDownIcon } from "../../../../assets/icons/arrow_down.svg";
import { NavLink, useLocation } from "react-router-dom";
import ActionButton from "../../../../components/Buttons/ActionButton";
import DeviceMenu from "../../Shared/DeviceMenu";
import DevicesHeader from "../../../../components/Header/DevicesHeader";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import { savePathToLocalStorage } from "../../../../utils/helpers";
import JoystickConveyor from "../../../../components/Manual/JoystickConveyor";
import { DeviceTypeId } from "../../../../constants/deviceTypes";

type Props = {
  match: any;
  device: any;
  label: string;
  icon: any;
};

const Control = (props: Props) => {
  savePathToLocalStorage();

  const deviceId = props.match.params.deviceId;
  // Get Device Data
  const { getDevice } = useDevice();
  const { device } = getDevice(parseInt(deviceId));

  // const run = (e: React.MouseEvent<HTMLElement>) => {

  //   var _inputs = {};
  //   inputs.forEach(element => {
  //       _inputs[element.label] = element.value;
  //   });

  //   console.log(props.did, props.deviceId, _inputs);
  //   runAction(props.did, (props.deviceId).toString(), _inputs);
  //   e.stopPropagation()
  // }
  // const updateInput = (newInput: any) => {
  //     var newInputs = inputs.map((input:any) => input.label == newInput.label ? input = newInput : input);
  //     setInputs(newInputs)
  // }


  const renderJoystick = (device: any) => {
    switch (device.deviceTypes.id) {
      case DeviceTypeId.PLC:
        return <JoystickConveyor deviceId={deviceId} authSocket={authSocket} />
      case DeviceTypeId.ROBOT_ARM:
        return <Joystick deviceId={deviceId} authSocket={authSocket} />
      default:
        return <Joystick deviceId={deviceId} authSocket={authSocket} />
    }
  };

  const { authSocket } = useAuthenticatedSocket();

  return device ? (
    <div className="device-main main-content">
      <DevicesHeader device={device} />
      <div className="manual-body-content">
        <div>
          <DeviceMenu typeId={device.deviceTypes.id} />
        </div>
        <div className="manual" style={{ flexDirection: "column" }}>
          {renderJoystick(device)}
          <ManualTerminal deviceId={deviceId} />
        </div>
      </div>
    </div>
  ) : (
    <LoadingSpinner />
  );
};

export default Control;
